import classNames from "classnames/dedupe";
import { CardPopover } from "../../QuoteCards/QuoteCard/InfoModal/CardPopover";

export const CancelAnytime = ({
  eventTrackerCallback,
  className,
}: CancelAnytimeProps) => {
  return (
    <div
      className={classNames(
        "mobius-cancel-anytime__popover-wrapper",
        className,
      )}
    >
      <CardPopover
        toggleText="Cancel anytime"
        body="You can easily cancel your insurance policy at any time during the policy period. Please note that penalties may apply."
        onOpen={eventTrackerCallback}
      />
    </div>
  );
};

export interface CancelAnytimeProps {
  eventTrackerCallback?: () => void;
  className?: string;
}

CancelAnytime.displayName = "CancelAnytime";
